import { Select, Typography } from 'antd';

export type FarmPickerOption = {
  value: string | number;
  label: string;
};

type FarmPickerFieldProps = {
  disabled?: boolean;
  label: string;
  loading?: boolean;
  onChange?: (value: string | number) => void;
  options: FarmPickerOption[];
  placeholder?: string;
  value?: string | number;
  /** When true, always show read-only text (no dropdown). */
  readOnly?: boolean;
};

export function FarmPickerField({
  disabled,
  label,
  loading,
  onChange,
  options,
  placeholder,
  value,
  readOnly = false,
}: FarmPickerFieldProps) {
  if (!options.length && !loading) {
    return null;
  }

  const selectedLabel = options.find((option) => option.value === value)?.label || options[0]?.label;
  const showAsText = readOnly || (options.length <= 1 && !loading);

  return (
    <div style={{ textAlign: 'left' }}>
      <Typography.Text
        style={{
          display: 'block',
          fontSize: 11,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: 0.9,
          color: '#98a2b3',
          marginBottom: 6,
        }}
      >
        {label}
      </Typography.Text>
      {showAsText ? (
        <Typography.Text
          style={{
            display: 'block',
            fontSize: 16,
            lineHeight: 1.3,
            fontWeight: 700,
            color: '#101828',
            wordBreak: 'break-word',
          }}
        >
          {selectedLabel}
        </Typography.Text>
      ) : (
        <Select
          aria-label={label}
          disabled={disabled || loading}
          loading={loading}
          onChange={onChange}
          optionFilterProp="label"
          options={options}
          placeholder={placeholder}
          showSearch
          size="large"
          value={value}
          style={{ width: '100%' }}
        />
      )}
    </div>
  );
}
